import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-default-sidebar',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './default-sidebar.component.html',
  styleUrl: './default-sidebar.component.scss',
})
export class DefaultSidebarComponent implements OnInit {
  // Track open items by path or index
  activePaths: string[] = [];
  currentUrl = '';

  toggleItem(path: string) {
    if (this.activePaths.includes(path)) {
      this.activePaths = this.activePaths.filter((p) => p !== path);
    } else {
      this.activePaths.push(path);
    }
  }
  isActive(path: string): boolean {
    return this.activePaths.includes(path);
  }

  isCurrentRoute(route: string): boolean {
    return this.currentUrl === route || this.currentUrl.startsWith(route + '/');
  }

  constructor(private router: Router) {
    this.currentUrl = this.router.url;
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((e: any) => {
      this.currentUrl = e.urlAfterRedirects;
      if (this.currentUrl.startsWith('/masters') && !this.activePaths.includes('masters')) {
        this.activePaths.push('masters');
      }
      if (this.currentUrl.startsWith('/operations') && !this.activePaths.includes('operations')) {
        this.activePaths.push('operations');
      }
      if (this.currentUrl.startsWith('/admin-control') && !this.activePaths.includes('admin')) {
        this.activePaths.push('admin');
      }
      if (this.currentUrl.startsWith('/campaign') && !this.activePaths.includes('campaign')) {
        this.activePaths.push('campaign');
      }
    });
  }

  ngOnInit(): void {
    if (this.currentUrl.startsWith('/masters')) {
      this.activePaths.push('masters');
    }
    if (this.currentUrl.startsWith('/operations')) {
      this.activePaths.push('operations');
    }
    if (this.currentUrl.startsWith('/admin-control')) {
      this.activePaths.push('admin');
    }
    if (this.currentUrl.startsWith('/campaign')) {
      this.activePaths.push('campaign');
    }
  }

  goToPage(route: string) {
    this.router.navigateByUrl(route);
  }
}
